module.exports = __webpack_public_path__ + "media/images/logos/oregon-logo-32x32-f0a63bfdecac3094320ab0fe43ba7e69.png";